export default __webpack_public_path__ + "static/media/mockup-image-03.469ed580.jpg";